<cp-auth-page-common>

  <div class="AuthPageControlsContainer"
    (keyup.enter)="onSaveNewPassword()">

    <div class="AuthPageControlsHeader">
      {{ 'DESIGN_B.RESET_PASSWORD.TITLE' | translate }}
    </div>

    <div class="AuthPageInfoTextContainer">
      {{ 'DESIGN_B.RESET_PASSWORD.INFO' | translate }}
    </div>

    <div class="AuthPageControlsLabel">
      {{ 'DESIGN_B.RESET_PASSWORD.PASSWORD' | translate }}
    </div>

    <div class="PasswordInputContainer"
      [popupOpen]="true"
      [ignoreClickOutside]="showPasswordInputErrors"
      (clickOutside)="onPasswordInputLostFocus()">
      <cp-form-input [form]="formGroup"
        [valueType]="ValueType.PASSWORD"
        [controlName]="PASSWORD">
      </cp-form-input>
    </div>

    @if (formGroup?.get(PASSWORD)?.value) {
      <div
        class="PasswordRequirementsContainer">
        <cp-password-requirements [form]="formGroup"
          [controlName]="PASSWORD"
          [showErrors]="showPasswordInputErrors">
        </cp-password-requirements>
      </div>
    }

    <hr>

      <div class="AuthPageControlsFooter">
        <span></span>
        <cp-button [size]="ButtonSize.MEDIUM"
          [disabled]="!isValid || inProgress"
          [text]="'DESIGN_B.RESET_PASSWORD.LOGIN' | translate"
          [stopPropagation]="false"
          [showSpinner]="inProgress"
          (buttonClick)="onSaveNewPassword()">
        </cp-button>
      </div>

    </div>

    @if (showResetFailedError) {
      <div
        class="AuthPageAlertMessageContainer">
        <cp-message-design-b-small [(visible)]="showResetFailedError"
          [messageText]="resetFailedText | translate">
        </cp-message-design-b-small>
      </div>
    }

  </cp-auth-page-common>
